import { render, staticRenderFns } from "./leftSideSkeleton.vue?vue&type=template&id=0658e134&scoped=true&"
import script from "./leftSideSkeleton.vue?vue&type=script&lang=js&"
export * from "./leftSideSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0658e134",
  null
  
)

export default component.exports